<template>
  <div>
    <p class="title is-3-desktop is-4-tablet is-5-mobile">Bandeja Socios</p>

    <section>
      <div class="block">
        <b-field>
          <b-select @input="loadItemMateriales" v-model="material" expanded placeholder="Seleccione Código de Barra"
            rounded>
            <option v-for="option in materiales" :value="option" :key="option.id">
              {{ option.code }} - {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <b-field v-if="material">
        <b-radio-button @input="selectTipoCarga" v-model="tipoCarga" native-value="IND"
          type="is-info is-light is-outlined">
          <span>Carga Individual</span>
        </b-radio-button>

        <b-radio-button @input="selectTipoCarga" v-model="tipoCarga" native-value="MAS"
          type="is-info is-light is-outlined">
          <span>Carga Masiva</span>
        </b-radio-button>
      </b-field>
    </section>

    <section v-if="tipoCarga == 'IND'" style="margin-top: 15px">
      <b-field grouped>
        <b-field label="Sistema Registro">
          <b-select v-model="itemMaterial.sistemaRegistro" rounded>
            <option v-for="option in sistemaRegistros" :value="option.valor" :key="option.id">
              {{ option.description }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Transacción">
          <b-select v-model="itemMaterial.transaccion" @input="cargarTipoTransaccion($event)" rounded>
            <option v-for="option in transacciones" :value="option.valor" :key="option.id">
              {{ option.description }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Tipo Transacción">
          <b-select v-model="itemMaterial.tipoTransaccion" rounded>
            <option v-for="option in tipoTransacciones" :value="option.valor" :key="option.id">
              {{ option.description }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Tipo Documento">
          <b-select @input="validateNroDocumento" v-model="itemMaterial.tipoDocumento" rounded>
            <option v-for="option in tipoDocumentos" :value="option.valor" :key="option.id">
              {{ option.description }}
            </option>
          </b-select>
        </b-field>

        <b-field label="N° Documento" :type="type" :message="message">
          <b-input @input="validateNroDocumentoKeyUp" type="text" v-model="itemMaterial.nroDocumento"
            :maxlength="maxlength">
          </b-input>
        </b-field>
      </b-field>

      <b-field grouped>
        <b-field label="Fecha de Transacción">
          <b-datepicker :max-date="minDate" v-model="itemMaterial.fechaTransaccion">
          </b-datepicker>
        </b-field>

        <b-field label="Identificador  Único">
          <b-input v-model="itemMaterial.identificador"></b-input>
        </b-field>

        <b-field label="Telefono/Celular">
          <b-input maxlength="10" v-model="itemMaterial.telefonoCelular"></b-input>
        </b-field>
      </b-field>

      <div class="level">
        <div class="level-item has-text-centered">
          <button v-if="itemMaterial.id" @click="saveItemMaterial" class="button is-success is-rounded"
            :disabled="!validate" type="is-success" icon-left="plus">
            Actualizar
          </button>

          <button v-else @click="saveItemMaterial" class="button is-success is-rounded" :disabled="!validate"
            type="is-success" icon-left="plus">
            Agregar
          </button>
          &nbsp;&nbsp;&nbsp;
          <button @click="limpiarMaterial" class="button is-light is-rounded" type="is-light" icon-left="plus">
            Limpiar
          </button>
        </div>
      </div>
      <!-- <div v-if="tipoCarga == 'IND'" align="center">
           <b-button
          @click="saveItemMaterial"
          type="is-success"
          icon-left="plus"
          outlined
          :disabled="!validate"
        >
          Agregar
        </b-button>
      </div> -->
    </section>

    <div class="btn-export report">
      Total Registros : {{ registros.totalElements }}
      Registros Válidos : {{ registrosValidos }}
      Registros No Válidos : {{ registrosNoValidos }}
    </div>

    <section style="margin-top: 15px">
      <b-table :data="registros.content" paginated backend-pagination :total="registros.totalElements"
        :per-page="searchOptions.perPage" @page-change="onPageChange" :current-page="searchOptions.pageNumber">
        <template slot-scope="props">
          <b-table-column label="#" class="is-size-7">
            {{ getrowIndex(props.index) + 1 }}
          </b-table-column>

          <b-table-column label="Sistema Registro" class="is-size-7">

            <b-tooltip v-if="props.row.validacionesItemMaterial" type="is-warning"
              :label="props.row.validacionesItemMaterial.msgErrorSistemaRegistro" position="is-right">
              <div v-if="
                props.row.validacionesItemMaterial.msgErrorSistemaRegistro === ''
              ">
                {{ props.row.sistemaRegistro }}
              </div>

              <div v-else>
                <a> {{ props.row.sistemaRegistro }}</a>
              </div>
            </b-tooltip>

            <div v-else>
              {{ props.row.sistemaRegistro }}
            </div>

          </b-table-column>

          <b-table-column label="Transacción" class="is-size-7">

            <b-tooltip v-if="props.row.validacionesItemMaterial" type="is-warning"
              :label="props.row.validacionesItemMaterial.msgErrorTransaccion" position="is-right">
              <div v-if="
                props.row.validacionesItemMaterial.msgErrorTransaccion === ''
              ">
                {{ props.row.transaccion }}
              </div>

              <div v-else>
                <a> {{ props.row.transaccion }}</a>
              </div>
            </b-tooltip>

            <div v-else>
              {{ props.row.transaccion }}
            </div>

          </b-table-column>

          <b-table-column label="Tipo Transacción" class="is-size-7">

            <b-tooltip v-if="props.row.validacionesItemMaterial" type="is-warning"
              :label="props.row.validacionesItemMaterial.msgErrorTipoTransaccion" position="is-right">
              <div v-if="
                props.row.validacionesItemMaterial.msgErrorTipoTransaccion === ''
              ">
                {{ props.row.tipoTransaccion }}
              </div>

              <div v-else>
                <a> {{ props.row.tipoTransaccion }}</a>
              </div>
            </b-tooltip>

            <div v-else>
              {{ props.row.tipoTransaccion }}
            </div>
          </b-table-column>

          <b-table-column label="Tipo Documento" class="is-size-7">
            {{ props.row.tipoDocumento }}
          </b-table-column>

          <b-table-column label="N° Documento" class="is-size-7">

            <b-tooltip v-if="props.row.validacionesItemMaterial" type="is-warning"
              :label="props.row.validacionesItemMaterial.msgErrorNroDocumento" position="is-right">
              <div v-if="
                props.row.validacionesItemMaterial.msgErrorNroDocumento === ''
              ">
                {{ props.row.nroDocumento }}
              </div>

              <div v-else>
                <a> {{ props.row.nroDocumento }}</a>
              </div>
            </b-tooltip>

            <div v-else>
              {{ props.row.nroDocumento }}
            </div>


          </b-table-column>

          <b-table-column label="Fecha de Transacción" class="is-size-7">
            {{ new Date(props.row.fechaTransaccion) | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Identificador Único" class="is-size-7">
            <b-tooltip v-if="props.row.validacionesItemMaterial" type="is-warning"
              :label="props.row.validacionesItemMaterial.msgErrorIdentificador" position="is-right">
              <div v-if="
                props.row.validacionesItemMaterial.msgErrorIdentificador ===
                ''
              ">
                {{ props.row.identificador }}
              </div>

              <div v-else>
                <a> {{ props.row.identificador }}</a>
              </div>
            </b-tooltip>
            <div v-else>
              {{ props.row.identificador }}
            </div>

          </b-table-column>

          <b-table-column label="Telefono/Celular" class="is-size-7">
            <b-tooltip v-if="props.row.validacionesItemMaterial" type="is-warning"
              :label="props.row.validacionesItemMaterial.msgErrorNroTelefono" position="is-right">
              <div v-if="
                props.row.validacionesItemMaterial.msgErrorNroTelefono === ''
              ">
                {{ props.row.telefonoCelular }}
              </div>

              <div v-else>
                <a> {{ props.row.telefonoCelular }}</a>
              </div>
            </b-tooltip>
            <div v-else>
              {{ props.row.telefonoCelular }}
            </div>

          </b-table-column>

          <b-table-column label="Código Oficina" class="is-size-7">
            {{ props.row.address.code }}
          </b-table-column>

          <b-table-column label="Nombre Oficina" class="is-size-7">
            {{ props.row.address.name }}
          </b-table-column>

          <b-table-column label="Registro" class="is-size-7">
            <span :class="[
              'tag',
              { 'is-danger': props.row.registroValido === false },
              { 'is-success': props.row.registroValido === true },
            ]">
              {{ getRegistroValido(props.row.registroValido) }}
            </span>
          </b-table-column>

          <b-table-column label="Acciones" width="50" class="is-size-7">
            <button @click="editarItemMaterial(props.row)" class="button is-small">
              <b-icon type="is-warning" icon="pencil"></b-icon>
            </button>

            <button @click="confirmDeleteItemMaterial(props.row)" class="button is-small">
              <b-icon type="is-danger" icon="delete"></b-icon>
            </button>
            <!-- <b-button
              @click="editarItemMaterial(props.row)"
              type="is-warning"
              icon-left="pencil"
              outlined
            >
            </b-button> -->

            <!-- <b-button
              @click="confirmDeleteItemMaterial(props.row)"
              type="is-danger"
              icon-left="delete"
              outlined
            >
            </b-button> -->
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
              </p>
              <p>No hay registros</p>
            </div>
          </section>
        </template>

        <template #footer>
          <div class="level-item has-text-centered">
            <button :disabled="validateRegistros" class="button is-info is-rounded"
              @click="sendBandejaDigitalizacionDialog" type="button">
              Enviar Bandeja Digitalización
            </button>
            &nbsp;&nbsp;&nbsp;
            <button :disabled="!registros.totalElements > 0" class="button is-danger is-rounded"
              @click="eliminarTodosRegistrosDialog" type="button">
              Eliminar Registros
            </button>
          </div>
        </template>
      </b-table>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Util from "../util";
import ImportarArchivo from "./modal/ImportarArchivo";

import SociosApi from "../../src/api/modules/SociosApi";

export default {
  data() {
    const today = new Date();
    return {
      tipoCarga: null,
      materiales: [],
      material: null,
      sistemaRegistros: [],
      registros: [],
      itemMaterial: {
        sistemaRegistro: null,
        transaccion: null,
        tipoTransaccion: null,
        tipoDocumento: null,
        nroDocumento: null,
        fechaTransaccion: null,
        identificador: null,
        telefonoCelular: null,
        idMaterial: null,
      },
      transacciones: [],
      tipoTransacciones: [],
      tipoDocumentos: [],
      searchOptions: {
        perPage: 10,
        pageNumber: 1,
      },
      hasError: true,
      type: null,
      message: null,
      maxlength: null,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      registrosValidos: 0,
      registrosNoValidos: 0,
    };
  },
  methods: {
    selectTipoCarga() {
      this.limpiarMaterial();
      if (this.material) {
        if (this.tipoCarga === "MAS") {
          this.openModalAttached(this.getClient.id, this.material.id);
        }
      } else {
        this.$toast.open({
          message: "Selecione Codigo de Barra",
          type: "is-danger",
        });
      }
    },

    onPageChange(page) {
      this.searchOptions.pageNumber = page;
      this.loadItemMateriales().then();
    },

    loadItemMateriales() {
      const params = [
        `pageNumber=${this.searchOptions.pageNumber}`,
        `perPage=${this.searchOptions.perPage}`,
      ].join("&");

      return new Promise((resolve, reject) => {
        SociosApi.getItemMateriales(this, {
          idClient: this.getClient.id,
          idMaterial: this.material.id,
          param: params,
        })
          .then((data) => {
            this.registros = data.materiales;
            this.registrosValidos = data.registrosValidos;
            this.registrosNoValidos = data.registrosNoValidos;
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    saveItemMaterial() {
      this.itemMaterial.idClient = this.getClient.id;
      this.itemMaterial.code = this.material.code;
      this.itemMaterial.registroValido = !this.hasError;

      return new Promise((resolve, reject) => {
        SociosApi.saveItemMaterial(this, {
          idClient: this.getClient.id,
          itemMaterial: this.itemMaterial,
        })
          .then((data) => {
            resolve(data);
            this.loadItemMateriales().then();
            (this.type = null), (this.message = null);
            this.hasError = true;
            this.itemMaterial = {};
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    loadMateriales() {
      let idAddress = Util.getUser().idAddress;
      return new Promise((resolve, reject) => {
        SociosApi.getMateriales(this, {
          idClient: this.getClient.id,
          idAddress: idAddress,
        })
          .then((data) => {
            this.materiales = data;
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    confirmDeleteItemMaterial(item) {
      this.$dialog.confirm({
        title: "Eliminar Item",
        message:
          "Está seguro que quiere <b>Eliminar</b> el item con <b> " +
          item.tipoDocumento +
          " : " +
          item.nroDocumento +
          "</b>?",
        confirmText: "Si",
        cancelText: "No",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteItemMaterial(item),
      });
    },

    deleteItemMaterial(item) {
      return new Promise((resolve, reject) => {
        SociosApi.deleteItemMaterial(this, { idItemMaterial: item.id })
          .then(() => {
            this.loadItemMateriales().then();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    cargarTipoTransaccion(event) {
      this.tipoTransacciones = Util.getParametroHijo("TIPO_TRANSACCION", event);
    },

    validateNroDocumento() {
      (this.type = null), (this.message = null);
      this.hasError = true;
      let element = Util.getParametroParam(
        "TIPO_DOCUMENTO",
        this.itemMaterial.tipoDocumento
      );
      if (element) {
        this.maxlength = element.caracteres;
      }
    },

    validateNroDocumentoKeyUp() {
      let caracteres = this.itemMaterial.nroDocumento;

      if (
        this.itemMaterial.tipoDocumento === "CE" ||
        this.itemMaterial.tipoDocumento === "OTROS"
      ) {
        if (caracteres.length <= this.maxlength) {
          (this.type = "is-success"), (this.message = "N° documento válido");
          this.hasError = false;
        } else {
          (this.type = "is-danger"), (this.message = "N° documento invalido");
          this.hasError = true;
        }
      } else {
        if (this.maxlength == caracteres.length) {
          (this.type = "is-success"), (this.message = "N° documento válido");
          this.hasError = false;
        } else {
          (this.type = "is-danger"), (this.message = "N° documento invalido");
          this.hasError = true;
        }
      }
    },

    editarItemMaterial(item) {
      this.tipoCarga = "IND";
      if (item.id) {
        this.itemMaterial = item;
        this.itemMaterial.fechaTransaccion = new Date(item.fechaTransaccion);
        this.cargarTipoTransaccion(item.transaccion);
        this.validateNroDocumento();
        this.validateNroDocumentoKeyUp();
      }
    },

    openModalAttached(idClient, idMaterial) {
      let material = {};
      material.idClient = idClient;
      material.idMaterial = idMaterial;
      material.idOrderMaterial = this.material.idOrderMaterial;
      material.code = this.material.code;

      this.$modal.open({
        parent: this,
        component: ImportarArchivo,
        hasModalCard: true,
        width: 960,
        props: { material, loadItemMateriales: this.loadItemMateriales },
      });
    },

    limpiarMaterial() {
      this.itemMaterial = {};
      (this.type = "is-danger"), (this.message = "N° documento invalido");
      this.hasError = true;
    },

    sendBandejaDigitalizacionDialog() {
      this.$dialog.confirm({
        title: "Enviar Bandeja Digitalización",
        message:
          "Está seguro que desea enviar los registros a la Bandeja de Digitalización?",
        confirmText: "Si",
        cancelText: "No",
        type: "is-success",
        hasIcon: true,
        onConfirm: () => {
          this.sendBandejaDigitalizacion();
        },
      });
    },

    sendBandejaDigitalizacion() {
      this.limpiarMaterial();
      return new Promise((resolve, reject) => {
        SociosApi.enviarBandejaDigitalizacion(this, {
          idClient: this.getClient.id,
          idMaterial: this.material.id,
        })
          .then((data) => {
            if (data) {
              this.$toast.open({
                duration: 5000,
                message:
                  "Se envió correctamente a la bandeja de Digitalización",
                type: "is-success",
              });
              this.material = {};
              this.loadMateriales();
              this.loadItemMateriales().then();
              this.material = null;
            }
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getRegistroValido(item) {
      if (item == true) {
        return "Si";
      } else {
        return "No";
      }
    },

    eliminarTodosRegistrosDialog() {
      this.$dialog.confirm({
        title: "Eliminar Registros",
        message: `Está seguro que desea eliminar ${this.registros.totalElements} registros ?`,
        confirmText: "Si",
        cancelText: "No",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.eliminarTodosRegistros();
        },
      });
    },

    eliminarTodosRegistros() {
      return new Promise((resolve, reject) => {
        SociosApi.eliminarTodosRegistros(this, {
          idItemMaterial: this.material.id,
          idClient: this.getClient.id,
        })
          .then(() => {
            this.loadItemMateriales().then();
            this.$toast.open({
              duration: 5000,
              message: "Registros eliminados correctamente!",
              type: "is-success",
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getrowIndex(item) {
      let contador =
        (this.searchOptions.pageNumber - 1) * this.searchOptions.perPage;
      return contador + item;
    },
  },

  computed: {
    ...mapGetters({
      getClient: "auth/getClient",
    }),

    validate() {
      if (this.material) {
        this.itemMaterial.idMaterial = this.material.id;
        this.itemMaterial.idOrderMaterial = this.material.idOrderMaterial;
      }

      return (
        this.itemMaterial.sistemaRegistro &&
        this.itemMaterial.transaccion &&
        this.itemMaterial.tipoTransaccion &&
        this.itemMaterial.tipoDocumento &&
        this.itemMaterial.nroDocumento &&
        this.itemMaterial.fechaTransaccion &&
        this.itemMaterial.identificador &&
        this.itemMaterial.telefonoCelular &&
        this.itemMaterial.idMaterial &&
        !this.hasError
      );
    },

    validateRegistros() {
      let registroSocios = this.registros.content;
      let habilitarButtonBandeja = true;
      if (registroSocios) {
        for (let index = 0; index < registroSocios.length; index++) {
          const element = registroSocios[index].registroValido;
          if (element == false) {
            habilitarButtonBandeja = true;
            break;
          } else {
            habilitarButtonBandeja = false;
          }
        }
      }
      return habilitarButtonBandeja;
    },
  },

  mounted() { },

  created() {
    this.loadMateriales().then();
    //Cargar Sistema Registro
    this.sistemaRegistros = Util.getParametro("SISTEMA_REGISTRO");
    this.transacciones = Util.getParametro("TRANSACCION");
    this.tipoDocumentos = Util.getParametro("TIPO_DOCUMENTO");
  },
};
</script>

<style scoped>
.report {
  margin-top: 30px;
}

.center {
  text-align: center;
}

.btn-export {
  text-align: right;
  margin-bottom: 0.25rem;
}

.break-word {
  word-break: break-all;
}

.colour-pdf {
  color: red;
}

.colour-excel {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/BandejaSocios.vue